/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .chart-container[_ngcontent-%COMP%]{height:460px}[_nghost-%COMP%]   .chart-container[_ngcontent-%COMP%]   .empty[_ngcontent-%COMP%]{height:100%;width:100%;display:flex;justify-content:center;align-items:center;opacity:.5}"];
export { styles as styles };
